// extracted by mini-css-extract-plugin
export default {"cajon_info":"info_cajon_info__xxM+1","titulo":"info_titulo__i-LGg"};